export async function sendCommandFlex35(descricao, action) {
    console.log(
        `comando enviado da lâmpada de ID ${descricao} com a ação ${action}`
      );
      var url =
        "https://terrazza.cmd-automacao.com/comandoFlex35" +
        "?buttonId=" +
        encodeURIComponent(descricao) +
        "&action=" +
        encodeURIComponent(action);
      console.log(action);
      fetch(url)
        .then((response) => {
          if (response.ok) {
            console.log("Comando enviado com sucesso.");
          } else {
            console.error("Erro ao enviar o comando.");
          }
        })
        .catch((error) => {
          console.error("Erro ao enviar o comando:", error);
        });
    }